

import Api from './api'
import Storage from '@/helpers/storage'

export default {

    connect: function (email, password, device, language) {

        return Api.put('/auth', {
            email: email,
            code: password,
            device: device,
            language: language,
            signUpReferrer: Storage.getItem('referrer'),
            signUpUtmSource: Storage.getItem('utm_source'),
            signUpUtmCampaign: Storage.getItem('utm_campaign'),
            signUpUtmMedium: Storage.getItem('utm_medium')
        })

    },

    disconnect() {

        const appInstanceId = Storage.getItem('firebaseAppInstanceId')
        return Api.post('/v3/users/logout', { appInstanceId })
            .catch(()=>{})

    },

    authCheck: function () {

        const aToken = Storage.getItem('aToken')
        return Api.get('/auth/check', { 'x-async-token': aToken })

    },

    deleteEmailAccount: function (email) {

        return Api.delete(`/v3/accounts/${ email }`)

    },

    deleteEmailAccountCheck: function (email) {

        const aToken = Storage.getItem('aToken')

        return Api.get(`/v3/accounts/${ email }/check`, { 'x-async-token': aToken })

    },

    sendMagicLinkEmail: function (email, language) {

        return Api.put('/auth/magic', { email, language })

    },

    getMagicLinkUser: function (code) {

        return Api.get('/auth/magic/check', { 'x-magic-token': code })

    },

    authLongCheck: function (code) {

        return Api.get('/auth/long/check', { 'X-Long-Auth-Token': code })

    },

    validConsent: function (body, utms) {

        if(utms.utm_source) { body.signUpUtmSource = utms.utm_source }

        if(utms.utm_campaign) { body.signUpUtmCampaign = utms.utm_campaign }

        if(utms.utm_medium) { body.signUpUtmMedium = utms.utm_medium }

        if(utms.referrer) { body.signUpReferrer = utms.referrer }

        return Api.put('/auth/consent', body)

    }

}
